
import { Component } from 'vue-property-decorator';
import 'firebase/firebase-firestore';
import LogsList, { LogFields, parseBoolean, parseEnum } from './LogsList.vue';

@Component
export default class BronchoscopyLogs extends LogsList {
  public getTitle(): string {
    return 'Bronchoscopy logs';
  }

  public getSpecificFields(): LogFields {
    return {
      bronchoscopyOnly: {
        label: 'Bronchoscopy only',
        formatter: parseBoolean
      },
      endobronchialBiopsy: {
        label: 'Endobronchial biopsy',
        formatter: parseBoolean
      },
      brushBiopsy: {
        label: 'Brush biopsy',
        formatter: parseBoolean
      },
      transbronchialBiopsy: {
        label: 'Transbronchial Biopsy',
        formatter: parseBoolean
      },
      washings: {
        label: 'Bronchoalveolar lavage/ washings',
        formatter: parseBoolean
      },
      ebus: {
        label: 'EBUS',
        formatter: parseBoolean
      },
      other: {
        label: 'Other or intervention'
      },
      biopsyResult: {
        label: 'Result of biopsy, etc.'
      },
      visibleTumourOrPositiveBiopsy: {
        label: 'Visible tumour and positive biopsy?'
      },
      supervisedOrIndependent: {
        label: 'Supervised or independent',
        formatter: parseEnum
      }
    };
  }

  protected getCollectionName(): string {
    return 'bronchoscopy-logs';
  }
}
